export default function createDataLoaders(api, axios) {
  const fetchProducts = async (productIds) => {
    try {
      const params = {
        search: `id:${productIds.join(',')}`,
        searchFields: 'id:in',
        limit: 0,
      };

      const { data } = await api.productsService.getAllProducts(params);
      return data ?? [];
    } catch (error) {
      console.error('Error fetching products:', error);
      return [];
    }
  };

  const fetchPromotion = async (promoId) => {
    try {
      const { data } = await axios.get(`/api/promotions/${promoId}`);
      return data?.data ?? [];
    } catch (error) {
      console.error('Error fetching promotion:', error);
      return [];
    }
  };

  const fetchInstagramPosts = async (limit) => {
    try {
      const { data } = await axios.get('/api/social/posts', {
        params: {
          network: 'instagram',
          ...(limit && { limit: String(limit) }),
        },
      });
      return data?.data ?? [];
    } catch (error) {
      console.error('Error fetching instagram posts:', error);
      return [];
    }
  };

  const fetchPages = async (tagId, lang = 'en') => {
    try {
      const { data } = await axios.get(
        `/api/pages/list?type=page&tag_ids[]=${tagId}&lang=${lang}`,
      );
      return data?.data ?? [];
    } catch (error) {
      console.error('Error fetching pages:', error);
      return [];
    }
  };

  return {
    fetchProducts,
    fetchPromotion,
    fetchInstagramPosts,
    fetchPages,
  };
}
